module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAA8klEQVQ4je3TvyuFcRTH8dfz+JJN6lLyIzY2k2TyF1jNyuSWsmAz+Bv8ATIqisHwWM1Gs0UZJBEu3a7hOYruc4ub0Wf6djrnfT7ndL5ZURR7WMW7UgmZ73rADabRQhO9OExYwzLWI3mrAjCFedSxgRls4yThBUdYjOQL7RqKRnXMRuwUt3nYGcUI3iqK4QpFvJsYDmgrRfAZ19FhsGKEPrxiH0s4xyPlwnKMYQcDmKwANKJgAmfYRA09nw7GcYmVDiNUaUF0F/Z+q8ZXQNf6B/wRIMd9F7V3yBL6MYcn7RfYSS3lp6olHGBXeco/BVA6P/4AwmEspwsZb/AAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/apps/38.png
// module id = 03Lp
// module chunks = 0